import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";

// Simple contact page so footer "Contact" no longer 404s.

export default function Contact() {
  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 py-12" data-testid="page-contact">
      <div className="text-[10px] uppercase tracking-widest font-black text-stone-500">Contact</div>
      <h1 className="heading text-3xl md:text-4xl font-extrabold text-stone-900">Get in touch</h1>
      <p className="text-stone-600 mt-2">We usually reply within a business day.</p>

      <div className="mt-8 space-y-4">
        <a
          href="mailto:hello@find2near.com"
          className="flex items-center gap-4 rounded-2xl border border-stone-200 bg-white p-4 hover:border-[#E05E36] transition-colors"
          data-testid="contact-email"
        >
          <div className="w-11 h-11 rounded-xl bg-[#FFF3EC] text-[#E05E36] grid place-items-center"><Mail size={20} /></div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-stone-500">Email</div>
            <div className="font-bold text-stone-900">hello@find2near.com</div>
          </div>
        </a>
        <a
          href="tel:+919999999999"
          className="flex items-center gap-4 rounded-2xl border border-stone-200 bg-white p-4 hover:border-[#2D5A27] transition-colors"
          data-testid="contact-phone"
        >
          <div className="w-11 h-11 rounded-xl bg-emerald-50 text-[#2D5A27] grid place-items-center"><Phone size={20} /></div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-stone-500">Phone</div>
            <div className="font-bold text-stone-900">+91 99999 99999</div>
          </div>
        </a>
        <div className="flex items-center gap-4 rounded-2xl border border-stone-200 bg-white p-4">
          <div className="w-11 h-11 rounded-xl bg-stone-100 text-stone-700 grid place-items-center"><MapPin size={20} /></div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-stone-500">Office</div>
            <div className="font-bold text-stone-900">Bengaluru, India</div>
          </div>
        </div>
      </div>
    </div>
  );
}
